import React, { useMemo, useEffect } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

import { setActiveVariable } from "reducers/Refinements";

import Thumbnail from "./Thumbnail";

import "./AdjustFramingThumbnailPanel.css";

export default function AdjustFramingThumbnailPanel(props) {
	const { variableConfig, activeVariableName, libraryId } = props;
	const dispatch = useDispatch();

	const imageVariables = useMemo(() => {
		const imageVariables = new Array();

		for (let variable in variableConfig) {
			const versionVariable = variableConfig[variable];

			// SVG files should be filtered out
			if (versionVariable.data?.match(/\.svg$/)) {
				continue;
			}

			if (versionVariable.type === "Image"
				&& versionVariable.cropMetadata?.frame?.width
				&& versionVariable.cropMetadata?.frame?.height) {
				imageVariables.push(versionVariable);
			}
		}

		return imageVariables;
	}, [variableConfig]);

	useEffect(() => {
		if (imageVariables.length > 0 && !activeVariableName) {
			// Set the first image variable as active
			// if no variable is active
			dispatch(setActiveVariable(imageVariables[0].name));
		}
	}, [activeVariableName, imageVariables]);

	return imageVariables.map((iv, index) => {
		return (
			<Thumbnail className={`cypress-image-thumbnail-${index+1}`}
				variableInfo={iv}
				isSelected={activeVariableName === iv.name}
				libraryId={libraryId}
				assetUrl={iv.assetUrl}
				key={iv.name} />
		);
	});
}


AdjustFramingThumbnailPanel.displayName = "AdjustFramingThumbnailPanel";
AdjustFramingThumbnailPanel.propTypes = {
	variableConfig: PropTypes.object.isRequired,
	activeVariableName: PropTypes.string,
	libraryId: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
};
